<template lang="html">

  <section class="cv-area -informacion-personal">


    <div class="datos-personales container row-start ais" v-if="!!cvdata">

      <a v-if="noedit" @click="back" class="volver">Volver</a>

      <nav class="breadcrumb">
        <router-link to="/">Home</router-link>
        <router-link :to="$t('enlaces.cv')" v-if="!noedit">Mi CV</router-link>
        <router-link :to="$t('enlaces.cv')" v-if="noedit">CV {{cvdata.nombre}} {{cvdata.apellido1}}
          {{cvdata.apellido2}}</router-link>
      </nav>


      <button @click="setEdit" class="cv-action-button edit" v-if="!showedit && !noedit"></button>

      <button @click="showedit= false" class="cv-action-button close" v-if="showedit">✕</button>

      <template v-if="!showedit">

        <div class="profile-img" :sexo="'H'" :empty="!!!img" :style="(!!img) ?
          `background: #f2f2f2 url(${img}) center/cover no-repeat` : null"></div>
        <div class="datos row-start">
          <h1 class="nombre">{{cvdata.nombre}} {{cvdata.apellido1}}
            {{cvdata.apellido2}}</h1>
          <div class="left">
            <p class="dato"><strong>DNI:</strong> {{cvdata.DNI}}</p>
            <p class="dato"><strong>Fecha Nacimiento:</strong>
              {{(cvdata.fecha_nacimiento) ? cvdata.fecha_nacimiento : 'Sin definir'}}</p>
            <p class="dato"><strong>Email:</strong> {{cvdata.email}}</p>
            <p class="dato"><strong>Teléfono Movil:</strong> {{cvdata.movil}}</p>
            <p class="dato"><strong>Teléfono:</strong> {{cvdata.telefono}}</p>
          </div>
          <div class="right">
            <p class="dato"><strong>Dirección:</strong>
              <template v-if="hasDireccion">
                <template v-if="!!cvdata.direccion">{{direccion}}</template><template v-if="!!cvdata.CP">,
                  {{cvdata.CP}}</template><template v-if="!!cvdata.ciudad">, {{cvdata.ciudad}}</template><template
                  v-if="!!cvdata.provincia">, {{cvdata.provincia}}</template><template v-if="!!cvdata.paisResidencia">,
                  {{cvdata.paisResidencia}}</template>
              </template>
              <template v-else>Sin definir</template>
            </p>
            <p class="dato">
              <strong>País de nacionalidad:</strong>
              {{(cvdata.nacionalidad) ? cvdata.nacionalidad : 'Sin definir'}}
            </p>
            <p class="dato">
              <strong>Sexo:</strong>
              {{(cvdata.sexo) ? cvdata.sexo : 'Sin definir'}}
            </p>

          </div>
        </div>

      </template>

      <template v-if="showedit">

        <div class="profile-img" :sexo="'H'" :empty="!!!img" :style="(!!img) ?
          `background: #f2f2f2 url(${img}) center/cover no-repeat` : null">
          <button class="btn" @click="showimgeditor= true">Editar</button>
        </div>


        <div class="datos -edit row-start">

          <div class="long-form row-start">

            <div class="contenedor-input" v-if="isAlumni">
              <label for="">Nombre*</label>
              <input type="text" v-validate="'required'" name="nombre" v-model="data.nombre">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
            </div>

            <div class="contenedor-input" v-if="isAlumni">
              <label for="">Primer apellido*</label>
              <input type="text" v-validate="'required'" name="apellido1" v-model="data.apellido1">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('apellido1')
                }}</span>
            </div>

            <div class="contenedor-input" v-if="isAlumni">
              <label for="">Segundo apellido*</label>
              <input type="text" v-validate="'required'" name="apellido2" v-model="data.apellido2">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('apellido2')
                }}</span>
            </div>

          </div>

          <div class="left">
            <div class="contenedor-input" v-if="isAlumni">
              <label>DNI</label>
              <input type="text" name="dni" v-validate="'length:9'" v-model="data.DNI">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni') }}</span>
            </div>

            <div class="contenedor-input">
              <label>Email</label>
              <input type="email" v-validate="'email'" name="email" v-model="data.email">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
            </div>
            <div class="contenedor-input">
              <label>Teléfono Movil</label>
              <input type="text" v-validate="'min:9'" name="movil" v-model="data.movil">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('movil') }}</span>
            </div>
            <div class="contenedor-input">
              <label>Teléfono</label>
              <input type="text" v-validate="'min:9'" name="telefono" v-model="data.telefono">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
            </div>

          </div>
          <div class="right">


            <div class="contenedor-input" v-if="isAlumni">
              <label>Fecha Nacimiento</label>
              <datepicker v-model="nacimiento" :language="es" :full-month-name="true" :monday-first="true"
                :format="'dd MMMM yyyy'"></datepicker>
            </div>

            <div class="contenedor-input" v-if="isAlumni">
              <label>País de nacimiento</label>
              <select v-model="data.idNacionalidad" name="pais">
                <option value="">Selecciona tu país de nacimiento</option>
                <option :value="pais[0]" v-for="pais in dominios.paises">{{pais[1]}}</option>
              </select>
            </div>

            <div class="contenedor-input" v-if="isAlumni">
              <label for="">Sexo*</label>
              <select name="sexo" v-model="data.sexo" v-validate="'required'">
                <option value="">Selecciona tu sexo*</option>
                <option value="masculino">Masculino</option>
                <option value="femenino">Femenino</option>
              </select>
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('sexo') }}</span>
            </div>

          </div>

          <div class="direccion row-start long-form">

            <h4 class="epigrafe">Dirección</h4>

            <div class="contenedor-input -thrid">
              <label>Tipo de via*</label>
              <select v-model="data.direccion.tipoDeViaCalle" v-validate="'required'" name="via">
                <option :value="data.id" v-for="data in vias">{{data.descripcion}}</option>
              </select>
            </div>

            <div class="contenedor-input row-start -sixth -no-margin">
              <label for="">Nombre de la calle*</label>
              <input type="text" v-model="data.direccion.direccion" name="calle" v-validate="'required'">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('calle') }}</span>
            </div>

            <div class="contenedor-input row-start -fifth">
              <label for="">Número*</label>
              <input type="text" v-model="data.direccion.numeroCalle" name="numero" v-validate="'required'">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('numero') }}</span>
            </div>

            <div class="contenedor-input row-start -fifth">
              <label for="">Escalera</label>
              <input type="text" v-model="data.direccion.escaleraCalle">
            </div>

            <div class="contenedor-input row-start -fifth">
              <label for="">Piso</label>
              <input type="text" v-model="data.direccion.pisoCalle">
            </div>
            <div class="contenedor-input row-start -fifth">
              <label for="">Puerta</label>
              <input type="text" v-model="data.direccion.puertaCalle">
            </div>
            <div class="contenedor-input row-start -fifth">
              <label for="">Letra</label>
              <input type="text" v-model="data.direccion.letraCalle">
            </div>

            <div class="contenedor-input -quarter">
              <label>Código postal*</label>
              <input type="text" v-model="data.CP" v-validate="'required'" name="cp">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('cp') }}</span>
            </div>

            <div class="contenedor-input -quarter">
              <label>País*</label>
              <select v-model="data.idPaisResidencia" name="pais" v-validate="'required'">
                <option value="">Selecciona tu país de residencia</option>
                <option :value="pais[0]" v-for="pais in dominios.paises">{{pais[1]}}</option>
              </select>
            </div>
            <div class="contenedor-input -quarter">
              <label>Provincia*</label>
              <input type="text" name="provincia" v-model="data.provincia" v-if="data.idPaisResidencia != 1" v-validate="'required'">
              <select v-else name="provincia" v-model="data.idprovincia" v-validate="'required'">
                <option value="">Selecciona tu provincia</option>
                <option v-for="provincia in dominios.provincias" :value="provincia[0]">{{provincia[1]}}</option>
              </select>
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('provincia') }}</span>
            </div>
            <div class="contenedor-input -quarter">
              <label>Localidad*</label>
              <input type="text" v-model="data.ciudad" v-validate="'required'" name="localidad">
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('localidad') }}</span>
            </div>

          </div>

          <div class="contenedor-boton">
            <button @click="send" class="btn" :loading="loading">Guardar</button>
          </div>

          <a @click="showChangePass= true" class="link -changepass">Cambiar
            contraseña</a>

        </div>



        <image-editor v-if="showimgeditor" @close="showimgeditor= false" @setImg="setImg" :avatarimg="img">
        </image-editor>

        <popup-pass v-if="showChangePass" @close="showChangePass= false"></popup-pass>
      </template>

    </div>

  </section>

</template>

<script lang="js">

  import imageeditor from '@/components/view-parts/espacio-personal/image-editor'
  import popuppass from '@/components/parts/popup-pass'

  import Datepicker from 'vuejs-datepicker';

  import { en, es } from 'vuejs-datepicker/dist/locale'

  import router from '@/router';


  import { mapGetters, mapActions } from 'vuex';

  import axios from 'axios';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  export default {
    name: 'informacion-personal',
    props: ['cvdata', 'imgperfil', 'noedit'],
    mounted() {
      if (!!this.imgperfil) {
        this.img = this.imgperfil;
      }
      this.getTiposVia();
    },
    data() {
      return {
        showedit: false,
        showimgeditor: false,
        img: '',
        showChangePass: false,
        en: en,
        es: es,
        clicked: false,
        nacimiento: '',
        loading: false,
        data: {
          nombre: "",
          apellido1: "",
          apellido2: "",
          DNI: "",
          fecha_nacimiento: "",
          email: "",
          telefono: "",
          movil: "",
          paisResidencia: "",
          idPaisResidencia: 0,
          direccion: "",
          CP: "",
          ciudad: "",
          provincia: "",
          idprovincia: 0
        },
        vias: ''
      }
    },
    components: {
      'image-editor': imageeditor,
      'popup-pass': popuppass,
      Datepicker,
    },
    methods: {
      ...mapActions(['requestUpdatePersonales']),
      setImg(value) {
        this.img = value;
      },
      setEdit() {

        for (let i in this.cvdata) {
          this.data[i] = this.cvdata[i];
        }

        if (!!this.data.fecha_nacimiento) {
          let date = this.data.fecha_nacimiento.split("/");
          this.nacimiento = new Date(date[2], date[1] - 1, date[0]);
        } else {
          this.nacimiento = new Date();
        }


        this.showedit = true;


      },
      send() {
        this.clicked = true;
        this.$validator.validateAll()
          .then(itsOk => {
            if (itsOk) {

              let data = JSON.parse(JSON.stringify(this.data));

              //SETEO DE NACIMIENTO
              let date = new Date(this.nacimiento);

              data.fecha_nacimiento = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

              (!!data.idprovincia && data.idPaisResidencia == "1") ? data.provincia = null : null;
              (data.idPaisResidencia != "1" && data.provincia) ? data.idprovincia = null : null;

              console.log(data);

              this.loading = true;

              this.requestUpdatePersonales(data).then(r => {
                this.loading = false;
                this.showedit = false;
              });

            }
          });
      },
      back() {
        router.go(-1)
      },
      getTiposVia() {
        axios.get(`/api/Alumno/dameTiposDeViCalle`).then(result => {
          if (result.data.status == 0) {
            this.vias = result.data.datos;
          }
        }).catch(error => {
          reject(false);
        });
      },
      getVia(via) {
        let selected;

        if (!!this.vias) {
          selected = this.vias.filter(v => v.id == via)[0];
        }

        return selected;

      }

    },
    computed: {
      ...mapGetters({
        dominios: 'getDominiosOrder',
        isAlumni: 'isAlumni'
      }),
      hasDireccion() {

        let show = false;

        let searchIn = ["direccion", "CP", "ciudad", "provincia", "paisResidencia"];

        searchIn.forEach(e => {
          (!!this.cvdata[e]) ? show = true : null;
        });

        return show;
      },
      direccion() {

        let data = this.cvdata.direccion;
        let tipo = this.getVia(data.tipoDeViaCalle);
        let direccion;


        if (!!tipo) {
          direccion = `${tipo.descripcion} ${data.direccion} ${data.numeroCalle}`;
          (!!data.escaleraCalle) ? direccion += `, escalera ${data.escaleraCalle}` : null;
          (!!data.pisoCalle) ? direccion += `, ${data.pisoCalle}º` : null;
        }




        return direccion;

      },
    },
    watch: {
      'imgperfil'() {
        if (!!this.imgperfil) {
          this.img = this.imgperfil;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .-changepass {
    margin-top: 30px;
  }

  .contenedor-boton {
    width: 100%;
  }

  @media screen and (max-width: 900px) {

    .long-form .contenedor-input.-sixth {
      width: calc(66.66666666% - 15px);
    }
  }

  @media screen and (max-width: 550px) {

    .long-form .contenedor-input.-sixth,
    .long-form .toggle-checkbox.-sixth {
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/informacion-personal.vue